import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=0c96d9a4&scoped=true"
import script from "./CategoryFilters.vue?vue&type=script&lang=js"
export * from "./CategoryFilters.vue?vue&type=script&lang=js"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=0c96d9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96d9a4",
  null
  
)

export default component.exports